var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.nodes
        ? _c("category-navbar", {
            staticClass: "mb-1",
            attrs: { filter: _vm.filter, nodes: _vm.nodes, "fav-key": "sfid" },
            on: {
              search: function ($event) {
                return _vm.onSearchChanged($event)
              },
              "delete-search": function ($event) {
                return _vm.resetFilter()
              },
              "on-filter-node": function ($event) {
                return _vm.onFilterCategory($event)
              },
              "toggle-favorites": function ($event) {
                return _vm.toggleFavorites($event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "breadcrumb bg-white ps-0" },
        [
          _vm._l(_vm.breadcrumbs, function (crumb, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "breadcrumb-item",
                class: { active: index + 1 == _vm.breadcrumbs.length },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onFilterCategory(crumb)
                      },
                    },
                  },
                  [_vm._v(_vm._s(crumb.name))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentNode || _vm.$route.query.search,
                  expression: "currentNode || $route.query.search",
                },
              ],
              staticClass: "text-muted",
            },
            [_vm._v(" (" + _vm._s(_vm.numExhibitors) + ")")]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.exhibitors.length > 0
        ? _c("span", [
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "d-none d-lg-block col col-lg-3" },
                _vm._l(_vm.nodes, function (node) {
                  return _c("div", { key: node.id }, [
                    _c(
                      "a",
                      {
                        staticClass: "no-deco",
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onFilterCategory(node)
                          },
                        },
                      },
                      [_vm._v(_vm._s(node.name))]
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col col-12 col-md-9" },
                _vm._l(_vm.exhibitors, function (exhibitor) {
                  return _c(
                    "div",
                    { key: exhibitor.id },
                    [
                      _c("exhibitor-row", {
                        attrs: {
                          exhibitor: exhibitor,
                          listDisplay: _vm.listDisplay,
                        },
                      }),
                      _vm._v(" "),
                      _c("category-pills", {
                        attrs: {
                          categories: exhibitor.categories,
                          "category-tree": _vm.tree,
                        },
                        on: {
                          "pill-clicked": function ($event) {
                            return _vm.onFilterCategory($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("hr"),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "py-3 text-center" }, [
              _c("button", { attrs: { disabled: _vm.page == 1 } }, [
                _c("i", {
                  staticClass: "fas fa-chevron-left",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.previousPage()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mx-3" }, [
                _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.numPages)),
              ]),
              _vm._v(" "),
              _c("button", { attrs: { disabled: _vm.page == _vm.numPages } }, [
                _c("i", {
                  staticClass: "fas fa-chevron-right",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.nextPage()
                    },
                  },
                }),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "text-center" }, [
              _vm._v("-- keine Treffer --"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }